import { isMobileNative } from 'app/utils/web-helpers';
import type { ComponentType } from 'react';
import React from 'react';
import Animated from 'react-native-reanimated';
import type { AnimatedProps } from 'react-native-reanimated';

export function withAnimated<Props extends object>(
  WrappedComponent: React.ComponentType<Props>,
): ComponentType<AnimatedProps<Props>> {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  class WithAnimated extends React.Component<Props> {
    static displayName = `WithAnimated(${displayName})`;

    render(): React.ReactNode {
      return <WrappedComponent {...this.props} />;
    }
  }

  return !isMobileNative
    ? (WrappedComponent as ComponentType<AnimatedProps<Props>>)
    : Animated.createAnimatedComponent(WithAnimated);
}
